import { useState } from 'react';
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import { DateTime } from 'luxon';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import { MonitorRunResultHostService } from 'shared/types';
import { DataRangePicker } from 'shared/ui/strspykit/DataRangePicker';

export interface DateRangePickerDialogProps {
    id?: string;
    monitor?: any;
    keepMounted?: boolean;
    loading?: boolean;
    open: boolean;
    fullScreen: boolean,
    initialStartDate?: DateTime,
    initialEndDate?: DateTime,
    onClose: () => void;
    onOk: (period: any) => void;
    children: string | JSX.Element | JSX.Element[]
}

export const DateRangePickerDialog = (props: DateRangePickerDialogProps): JSX.Element => {
    const {
        monitor,
        onClose,
        onOk,
        open,
        keepMounted,
        loading = false,
        initialStartDate,
        initialEndDate,
        children,
        ...other
    } = props

    const [startDate, setStartDate] = useState<DateTime | undefined>(initialStartDate);
    const [endDate, setEndDate] = useState<DateTime | undefined>(initialEndDate);

    useEffect(() => {
        setStartDate(initialStartDate)
        setEndDate(initialEndDate)
    }, [initialStartDate, initialEndDate])


    const handleClose = () => {
        onClose();
    };

    const handleOk = () => {
        if (startDate && endDate) {
            onOk({
                startDate: startDate,
                endDate: endDate
            });
        }
    }

    const handleStartDateChange = (startDate: DateTime) => {
        setStartDate(startDate)
    }

    const handleEndDateChange = (endDate: DateTime) => {
        setEndDate(endDate)
    }

    return (
        <Dialog
            sx={{ '& .MuiDialog-paper': { width: 'auto', maxHeight: '590px' } }}
            keepMounted
            maxWidth="xs"
            open={open}
            {...other}
        >
            <DialogContent dividers>
                <DataRangePicker
                    //loading={loading}
                    startDate={startDate}
                    endDate={endDate}
                    onStartDateChange={handleStartDateChange}
                    onEndDateChange={handleEndDateChange}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    autoFocus
                    onClick={handleOk}           
                >
                    Ok
                </Button>
                <Button
                    autoFocus
                    onClick={handleClose}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}